const query = (id, isPreview) => `{
  linksWithContent(id: "${id}",preview: ${isPreview}){
    title
    description
    variant
    linksCollection {
      items {
        __typename ... on Link {
        name
        url
        isActiveLink
        label
        title
        target
        scrollToElementId
        imageType
        gaEventClass
        gaEventLabel
        ariaLabel
        elementId
        }
      }
    } 
  }
}`

module.exports = { query }
